export const MAX_VISIT_PRICE = 9999

export const ACCOUNT_SETTINGS_TAB_NAME = 'Account'
export const SECURITY_SETTINGS_TAB_NAME = 'Security'
export const ACCOUNT_SETTINGS_NOT_EDIT_MODE_PAGE_TITLE = 'Account settings'
export const GO_TO_ARROW_TABLETS_ICON_ALT = 'gotoIntakeFormIcon'
export const ACCOUNT_SETTINGS_EDIT_ACCOUNT_TAB_PAGE_TITLE = 'Edit general information'
export const ACCOUNT_SETTINGS_EDIT_SECURITY_TAB_PAGE_TITLE = 'Edit password'
export const CLEAR_TEXT = 'Clear'
export const VISIT_FILTER_DROPDOWN_LABEL = 'Service type (Visit type)'
export const STATUS_FILTER_DROPDOWN_LABEL = 'Visit status'
export const TAGS_FILTER_DROPDOWN_LABEL = 'Tags'
export const ACCOUNT_SETTINGS_RELOAD_PAGE_POP_UP_TEXT = 'Do you want to leave this page?'
export const ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_TITLE_TEXT = 'Unsaved changes'
export const ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_SAVE_BTN_TEXT = 'Save changes'
export const ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_CANCEL_BTN_TEXT = 'Discard changes'
export const ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_BODY_TEXT =
  'You have unsaved changes made to the account which will be lost if you navigate away. Would you like to save these changes?'
export const DISCARD_CHANGES_POP_UP_TITLE_TEXT = 'Discard changes?'
export const DISCARD_CHANGES_POP_UP_BODY_TEXT_1 = 'Your changes to'
export const DISCARD_CHANGES_POP_UP_BODY_TEXT_2 = 'won’t be saved.'
// Fallback body when the edited entity has no display name yet (e.g. a brand-new item).
export const DISCARD_CHANGES_POP_UP_BODY_TEXT_GENERIC = 'Your changes won’t be saved.'
export const DISCARD_CHANGES_POP_UP_DISCARD_BTN_TEXT = 'Discard changes'
export const DISCARD_CHANGES_POP_UP_KEEP_EDITING_BTN_TEXT = 'Keep editing'
export const ERROR_TOAST_IMG_ALT_TEXT = 'errorIcon'
export const MANAGEMENT_ACTIVE_SIDE_PANEL_TAB = 'Management'
export const MANAGEMENT_PROVIDER_TABS_CRUMB_NAMES = {
  GENERAL: 'General',
  LICENSES: 'Licenses',
}

export const PREFIX_DOCTOR_NAME_OPTIONS = [' ', 'Dr.', 'Mr.', 'Mrs.', 'Ms.', 'Prof.']
export const SUFFIX_DOCTOR_NAME_OPTIONS = [' ', 'DO', 'MD', 'MPH', 'NP', 'PA', 'PhD', 'RN']

// local storage keys
export const PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY = 'previousTabsAccountSettings'
export const IS_SIDE_PANEL_COLLAPSED_KEY = 'isSidePanelCollapsed'

// AccountStatus from API values
export const ACCOUNT_STATUS_OK = 'ok'
export const ACCOUNT_STATUS_TREAT_ERROR = 'treaterror'
export const ACCOUNT_STATUS_BLOCKED = 'blocked'

// routes
export const MEDICATIONS_PAGE_ROUTE = '/medications'
export const MEDICATIONS_ADD_ROUTE = '/medications/add'
export const MEDICATIONS_EDIT_ROUTE = '/medications/edit'
export const MEDICATIONS_LABEL = 'Medications'
export const ACCOUNT_SETTINGS_ROUTE = '/accountsettings'
export const VISITS_PAGE_ROUTE = '/visits'
export const MANAGEMENT_PAGE_ROUTE = '/management'
export const MEMBER_PAGE_ROUTE = '/management/member'
export const LICENSE_ADD_ROUTE = '/management/member/license/add'
export const LICENSE_EDIT_ROUTE = '/management/member/license/edit'
export const NEW_INTAKE_FORM_ROUTE = '/management/new-intake-form'
export const VIEW_INTAKE_FORM_ROUTE = '/management/view-intake-form'
export const PATIENT_CHARTS_PAGE_ROUTE = '/patientcharts'
export const MERGE_PATIENT_ACCOUNTS_ROUTE = '/patientcharts/merge-accounts'
export const PATIENT_CHART_PAGE_ROUTE = '/patient-chart'
export const AVAILABILITY_ROUTE = '/availability'
export const CREATE_NEW_SERVICE_TYPE_ROUTE = '/management/new-service'
export const NOT_FOUND_PAGE_ROUTE = '/NotFound404'
export const HOME_PAGE_ROUTE = '/'
export const AUTH_VALIDATE_ROUTE = '/auth/validate'
export const SANDBOX_PAGE_ROUTE = '/sandbox'
export const PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH = '/patientcharts/patient/intake-questions'
export const EDIT_STATE_OPTIONS_PAGE_ROUTE = '/management/state'

export const AVAILABILITY_LABEL = 'Availability'
export const MANAGEMENT_LABEL = 'Management'
export const PATIENT_PAST_VISIT_ROUTE = '/patient-past-visit-notes'
export const PATIENT_UPCOMING_VISIT_DETAILS_ROUTE = '/patient-upcoming-visit-notes'
export const VISITS_LABEL = 'Visits'
export const NEW_VISIT_ROUTE = '/availability/calendar/new-visit'
export const PRINTED_FRIENDLY_PATIENT_CHARTS = '/patientcharts/pdf'
export const NEW_VISIT_MANAGEMENT_ROUTE = '/management/calendar/new-visit'
export const NEW_VISIT_VISITS_ROUTE = '/visits/calendar/new-visit'
export const AVAILABILITY_CALENDAR_ROUTE = '/availability/calendar'
export const MANAGEMENT_CALENDAR_ROUTE = '/management/calendar'
export const VISITS_CALENDAR_ROUTE = '/visits/calendar'
export const VERIFY_EMAIL_PAGE_PATH = '/verifyemail'
export const FORGOT_PASSWORD_PAGE_PATH = '/forgot-password'
export const RESET_PASSWORD_PAGE_PATH = '/resetPassword'
export const RESCHEDULE_VISIT_PAGE_PATH = '/rescheduleVisit'

// Google Autocomplete keys
export const STREET_NUMBER_KEY = 'street_number'
export const ROUTE_KEY = 'route'
export const LOCALITY_KEY = 'locality'
export const ADMINISTRATIVE_AREA_LEVEL_1_KEY = 'administrative_area_level_1'
export const POSTAL_CODE_KEY = 'postal_code'
export const COUNTRY = 'country'

// errors
export const PATIENT_NOT_FOUND_ERROR = 'PatientNotFound'
export const EMAIL_NOT_UNIQUE_ERROR = 'EmailNotUnique'
export const ALLERGY_NAME_NOT_UNIQUE = 'AllergyNameNotUnique'
export const ALLERGY_NAME_NOT_VALID = 'AllergyNameNotValid'
export const PHONE_NUMBER_NOT_VALID = 'PhoneNumberNotValid'

// Visits sorting
export const VISITS_ALL_SORT_CONDITION = 'All'
export const VISITS_PATIENT_NAME_SORT_CONDITION = "Patient's name"
export const VISITS_PATIENT_EMAIL_SORT_CONDITION = "Patient's email"
export const VISITS_MRN_SORT_CONDITION = 'MRN'
export const VISITS_PROVIDER_NAME_SORT_CONDITION = "Provider's name"
export const VISITS_PAYMENT_ID_SORT_CONDITION = 'Payment ID'

export const VISITS_ALL_REQUEST_CONDITION = 'all'
export const VISITS_PATIENT_NAME_REQUEST_CONDITION = 'patientname'
export const VISITS_PATIENT_EMAIL_REQUEST_CONDITION = 'patientemail'
export const VISITS_MRN_REQUEST_CONDITION = 'patientmedicalrecordnumber'
export const VISITS_PROVIDER_NAME_REQUEST_CONDITION = 'providername'
export const VISITS_PAYMENT_ID_REQUEST_CONDITION = 'paymenttransactionid'

// search request conditions
export const ALL_SEARCH_REQUEST_CONDITION = 'all'
export const FULL_NAME_SEARCH_REQUEST_CONDITION = 'name'
export const EMAIL_SEARCH_REQUEST_CONDITION = 'email'
export const DOB_SEARCH_REQUEST_CONDITION = 'birthdate'
export const MRN_SEARCH_REQUEST_CONDITION = 'medicalrecordnumber'

// IntakeForms
export const INTAKE_FORMS_NEW_BTN_TEXT = 'New'
export const INTAKE_FORMS_CANCEL_BTN_TEXT = 'Cancel'
export const INTAKE_FORMS_SAVE_BTN_TEXT = 'Create'
export const INTAKE_FORMS_NEW_BTN_ID = 'newIntakeFormsBtn'
export const INTAKE_FORMS_NEW_BTN_IMG_ALT = 'addIntakeForm'
export const INTAKE_FORMS_TABLE_TITLE_PRIMARY_TEXT = 'Intake form'
export const INTAKE_FORMS_PATIENT_CHARTS_PRIMARY_TEXT = 'Intake forms'
export const INTAKE_FORMS_TABLE_TITLE_SECONDARY_TEXT = 'Create intake forms for patients'
export const INTAKE_FORMS_EMPTY_TABLE_TITLE = 'Currently no intake forms.'
export const INTAKE_FORMS_CREATE_FORM_TITLE_TEXT = 'New intake'
export const INTAKE_FORMS_QUESTIONS_BLOCK_TITLE_TEXT = 'Questions'
export const INTAKE_FORMS_CREATE_FORM_CANCEL_BTN_ID = 'createNewIntakeCancelBtn'
export const INTAKE_FORMS_CREATE_FORM_SAVE_BTN_ID = 'createNewIntakeSaveBtn'
export const INTAKE_INFO_TITLE_TEXT = 'Intake info'
export const INTAKE_INFO_NAME_INPUT_LABEL = 'Intake name*'
export const INTAKE_INFO_NAME_INPUT_ID = 'newIntakeNameInput'
export const INTAKE_FORM_TITLE_ID = 'intakeFormNameViewMode'
export const INTAKE_FORM_TABLET_TITLE_ID = 'intakeFormTableTitleNameViewMode'
export const INTAKE_TABLE_NAME_ID = 'intakeFormName'
export const INTAKE_INFO_NAME_MAX_LENGTH = 70
export const INTAKE_FORMS_CREATE_QUESTION_CANCEL_BTN_ID = 'createNewIntakeQuestionCancelBtn'
export const INTAKE_FORMS_CREATE_QUESTION_SAVE_BTN_ID = 'createNewIntakeQuestionSaveBtn'
export const INTAKE_FORMS_CREATE_QUESTION_NEW_QUESTION_BTN_ID = 'createNewIntakeQuestionNewQuestionBtn'
export const INTAKE_FORMS_CREATE_QUESTION_SAVE_BTN_LABEL_TEXT = 'Save'
export const INTAKE_FORMS_CREATE_QUESTION_NEW_QUESTION_LABEL_TEXT = 'New question'
export const INTAKE_FORMS_CREATE_QUESTION_SELECT_FILE_FORMAT_LABEL_TEXT = 'File format(s)'
export const INTAKE_FORMS_CREATE_QUESTION_SELECT_FILE_FORMAT_ID = 'selectFileFormatDropDown'
export const INTAKE_FORMS_CREATE_QUESTION_SELECT_QUESTION_TYPE_LABEL_TEXT = 'Select question type*'
export const INTAKE_FORMS_CREATE_QUESTION_SELECT_QUESTION_TYPE_ID = 'questionTypeDropDown'
export const INTAKE_FORM_TYPE_STATEMENT_TEXT = 'Statement'
export const INTAKE_FORM_TYPE_TEXT_BOX_TEXT = 'Text box'
export const INTAKE_FORM_TYPE_SINGLE_TEXT = 'Single select w/ Follow up'
export const INTAKE_FORM_TYPE_FILE_UPLOAD_BOX_TEXT = 'File upload'
export const INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT = 'Select pharmacy'
export const INTAKE_FORM_TYPE_FILE_UPLOAD_BOX_REQUEST_TEXT = 'file'
export const INTAKE_FORM_TYPE_FILE_UPLOAD_BOX_REQUEST_DOCUMENT_TEXT = 'document'
export const INTAKE_FORM_TYPE_FILE_UPLOAD_BOX_REQUEST_IMAGE_TEXT = 'image'
export const INTAKE_FORM_TYPE_EMAIL_TEXT = 'Email'
export const INTAKE_FORM_TYPE_EMAIL_REQUEST_TEXT = 'email'
export const INTAKE_FORM_TYPE_DATE_TEXT = 'Date'
export const INTAKE_FORM_TYPE_DATE_REQUEST_TEXT = 'date'
export const INTAKE_FORM_TYPE_PHONE_NUMBER_TEXT = 'Phone number'
export const INTAKE_FORM_TYPE_PHONE_NUMBER_REQUEST_TEXT = 'phone'
export const INTAKE_FORM_TYPE_MULTIPLE_CHOICE_TEXT = 'Multiple choice'
export const INTAKE_FORM_TYPE_HEIGHT_WEIGHT_TEXT = 'Height & Weight'
export const INTAKE_FORM_TYPE_HEIGHT_WEIGHT_REQUEST_TEXT = 'height_weight'
export const INTAKE_FORM_PREFERRED_PHARMACY_QUESTION = 'What is your preferred pharmacy'

export const NEW_INTAKE_FORM_QUESTION_TYPES = [
  INTAKE_FORM_TYPE_EMAIL_TEXT,
  INTAKE_FORM_TYPE_MULTIPLE_CHOICE_TEXT,
  INTAKE_FORM_TYPE_STATEMENT_TEXT,
  INTAKE_FORM_TYPE_TEXT_BOX_TEXT,
  INTAKE_FORM_TYPE_SINGLE_TEXT,
  INTAKE_FORM_TYPE_HEIGHT_WEIGHT_TEXT,
  INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT,
]

export const FILE_UPLOAD_DOCUMENT_TYPE_TEXT = 'Document (PDF, CSV, Word Document)'
export const FILE_UPLOAD_DOCUMENT_ALLOWED_FORMATS = ['.pdf', '.csv', '.doc', '.docx']
export const FILE_UPLOAD_IMAGE_ALLOWED_FORMATS = ['.jpeg', '.jpg', '.bmp', '.png', '.heic']
export const FILE_UPLOAD_IMAGE_FILE_TYPE_TEXT = 'Image file'

export const INTAKE_FORM_TYPE_STATEMENT_REQUEST_TEXT = 'statement'
export const INTAKE_FORM_TYPE_TEXT_BOX_REQUEST_TEXT = 'textbox'

export const INTAKE_FORM_TYPE_MULTIPLE_CHOICE_REQUEST_TEXT = 'option'
export const INTAKE_FORM_NEW_QUESTION_MULTIPLE_ANSWERS_CHECKBOX_TEXT = 'Enable multiple answers'
export const INTAKE_FORM_ANSWERS_OPTION_TITLE = 'Options'

export const AVAILABILITY_TABLE_ITEM_PROVIDER_NAME_TOOLTIP_CHECK_POINT = 'userName'
export const AVAILABILITY_TABLE_ITEM_AVAILABILITIES_TOOLTIP_CHECK_POINT = 'availabilities'
export const AVAILABILITY_TABLE_ITEM_UNAVAILABILITIES_TOOLTIP_CHECK_POINT = 'unavailabilities'
export const AVAILABILITY_TABLE_ITEM_LICENSE_STATES_TOOLTIP_CHECK_POINT = 'licensedStates'
export const AVAILABILITY_TABLE_ITEM_VISIT_TYPES_TOOLTIP_CHECK_POINT = 'visitTypes'
export const NO_AVAILABLE_PROVIDER_TABLE_EMPTY_TEXT = 'No available providers.'

export const EMPTY_VALUE_TEXT = '--'
export const ASTERISK_TEXT = '*'
export const ALLERGY_TEXT = 'Allergy'
export const SEVERITY_TEXT = 'Severity'
export const CONFIRM_TEXT = 'Confirm'
export const DAILY_TEXT = 'daily'
export const DAYS_TEXT = 'Day(s)'
export const WEEKLY_TEXT = 'weekly'
export const WEEKS_TEXT = 'Week(s)'
export const MONTHLY_TEXT = 'monthly'
export const MONTH_TEXT = 'Month(s)'
export const MONDAY = 'Monday'
export const TUESDAY = 'Tuesday'
export const WEDNESDAY = 'Wednesday'
export const THURSDAY = 'Thursday'
export const FRIDAY = 'Friday'
export const SATURDAY = 'Saturday'
export const SUNDAY = 'Sunday'
export const DETAILS_INFO_TYPE_PNB = 'PNB'
export const DETAILS_INFO_TYPE_AVAILABILITY = 'availability'
export const DATE_FORMAT_TYPE_DATE = 'Date'
export const DATE_FORMAT_TYPE_TIME = 'Time'
export const APPOINTMENT_VIEW_TYPE_LABEL = 'appointment'
export const CLINIC_MEMBERS_TEXT = 'Clinic members'
export const FIRST_NAME_TEXT = 'First name'
export const EMAIL_ADDRESS_TEXT = 'Email address'
export const HEIGHT_TEXT = 'Height'
export const MARITAL_STATUS_TEXT = 'Marital status'
export const GENDER_IDENTITY = 'Gender identity'
export const RACIAL_BACKGROUND = 'Racial background'
export const SEX_AT_BIRTH_TEXT = 'Sex at birth'
export const WEIGHT_TEXT = 'Weight'
export const LAST_NAME_TEXT = 'Last name'
export const DELETE_TEXT = 'Delete'
export const REVERT_ALL_PRODUCTIVITY_TEXT = 'Revert to default'
export const OK_TEXT = 'OK'
export const DELETE_A_USER_TEXT = 'Delete a user'
export const DELETE_SERVICE_TYPE = 'Delete service type?'
export const DELETE_USER_POPUP_MESSAGE_TEXT =
  'You are about to delete a user record. This step is irreversible. Are you sure you want to continue?'
export const DELETE_SERVICE_TYPE_POPUP_MESSAGE_TEXT =
  'This will delete the service type and all associated visit types. Are you sure you want to proceed?'
export const EDIT_TEXT = 'Edit'
export const PENDING_INVITATION_TEXT = 'Pending invitation'
export const PERSON_NOT_ACTIVATED_TEXT = 'This person has not activated their account yet'
export const RESEND_TEXT = 'Resend'
export const GENERAL_INFORMATION_TEXT = 'General information'
export const PREFIX_TEXT = 'Prefix'
export const SUFFIX_TEXT = 'Suffix'
export const ROLE_TEXT = 'Role'
export const PROFESSIONAL_TITLE_TEXT = 'Professional title'
export const LICENSE_INFORMATION_TEXT = 'Licenses'
export const PRODUCTIVITY_INFORMATION_TEXT = 'Productivity'
export const INVITATION_SENT_TEXT = 'Invitation sent!'
export const MRN_TEXT = 'MRN'
export const DOB_TEXT = 'DOB'
export const STATE_TEXT = 'State'
export const LAST_SEEN_TEXT = 'Last seen'
export const PATIENT_CHARTS_TEXT = 'Patient charts'
export const PREFERRED_NAME_TEXT = 'Preferred name'
export const PRINT_BUTTON_TEXT = 'Print'
export const ON_HOLD_CONFIRMATION_POP_UP_HEADER = 'On hold status'
export const ON_HOLD_CONFIRMATION_POP_UP_PRIMARY_BTN_TEXT = 'Yes, continue'
export const ON_HOLD_CONFIRMATION_POP_UP_SECONDARY_BTN_TEXT = 'Cancel'
export const ON_HOLD_CONFIRMATION_POP_UP_BODY_TEXT = 'Do you wish to continue?'
export const PERSONAL_TEXT = 'Personal'
export const BODY_MEASUREMENT = 'Body measurements'
export const IDENTITY_SECTION = 'Identity'
export const DATE_FORMAT_TEXT = '(MM/DD/YYYY)'
export const CONTACT_TEXT = 'Contact'
export const STREET_ADDRESS_TEXT = 'Street address'
export const PREFERRED_PHARMACY_TEXT = 'Preferred pharmacy'
export const EMERGENCY_CONTACT_TEXT = 'Emergency contact'
export const RELATIONSHIP_TO_PATIENT_TEXT = 'Relationship to patient'
export const VISIT_CREDIT_TEXT = 'Visit credit'
export const ACCOUNT_INFORMATION_TEXT = 'Account information'
export const LAST_UPDATED_TEXT = 'Last updated'
export const ALERTS_TEXT = 'Alerts'
export const ALERT_TEXT = 'Alert'
export const COUNT = 'count'
export const OFFSET = 'offset'
export const FILE_LOWER = 'file'
export const FILE_TAG_LOWER = 'file tag'
export const GENERAL_INFORMATION = 'General information'
export const VISIT_REMARKS_TITLE = 'Visit remarks'
export const NO_ALERTS_TEXT = 'No alerts'
export const ALLERGIES_TEXT = 'Allergies'
export const PATIENT_TEXT = 'Patient'
export const EMAIL_TEXT = 'Email'
export const NEW_ALERT_TEXT = 'New alert'
export const EDIT_ALERT_TEXT = 'Edit alert'
export const ON_HOLD_PATIENT_STATUS_TEXT = 'On hold status'
export const VISIBLE_TO_ALL_TEXT = 'Visible to all'
export const TYPE_SOMETHING_TEXT = 'Type something...'
export const YES_TEXT = 'yes'
export const NO_TEXT = 'no'
export const ADDRESS_TEXT = 'Address'
export const ALERT_MESSAGE_TEXT = 'Alert message'
export const ALLERGY_NAME_TEXT = 'Allergy name'
export const ALL_TEXT = 'All'
export const FULL_NAME_TEXT = 'Full name'
export const NO_RESULTS_TEXT = 'No results'
export const NEW_TEXT = 'New'
export const SAVE_TEXT = 'Save'
export const DOB_WITH_FORMAT_TEXT = 'DOB (MM/DD/YYYY)'
export const STREET_ADDRESS_1_TEXT = 'Street address 1'
export const STREET_ADDRESS_2_TEXT = 'Street address 2'
export const CITY_TEXT = 'City'
export const ZIP_CODE_TEXT = 'ZIP code'
export const EDIT_VISIT_CREDIT_TEXT = 'Edit visit credit'
export const CURRENT_CREDIT_TEXT = 'Current credit'
export const ADD_TEXT = 'Add'
export const DEDUCT_TEXT = 'Deduct'
export const CREDIT_REASON_TEXT = 'Credit reason'
export const UPDATE_TEXT = 'Update'

// Account credits
export const ACCOUNT_CREDITS_TEXT = 'Account credits'
export const GENERAL_CREDITS_TEXT = 'General credits'
export const REFERRAL_CREDITS_TEXT = 'Referral credits'
export const TOTAL_TEXT = 'Total'
export const EDIT_GENERAL_CREDITS_TEXT = 'Edit general credits'
export const EDIT_REFERRAL_CREDITS_TEXT = 'Edit referral credits'
export const REFERRAL_CREDITS_NOTE_TEXT = 'Please note: referral credits cannot be used for addiction treatment.'
export const ENTER_AMOUNT_TEXT = 'Enter amount'
export const CURRENT_BALANCE_TEXT = 'Current balance'
export const NEW_BALANCE_TEXT = 'New balance'
export const REASON_FOR_GENERAL_CREDITS_TEXT = 'Reason for general credits'
export const REASON_FOR_REFERRAL_CREDITS_TEXT = 'Reason for referral credits'
export const SELECT_REASON_TEXT = 'Select reason'
export const CREDIT_EXPIRATION_DATE_TEXT = 'Credit expiration date'
export const ADDITIONAL_INFORMATION_TEXT = 'Additional information'
export const UPDATE_CREDITS_TEXT = 'Update credits'
export const CREDITS_UPDATED_TEXT = 'Credits updated!'

// Quit 7-OH Plan — visit balance (QMD-4371)
export const CANCEL_PLAN_TEXT = 'Cancel plan'
export const EDIT_PLAN_VISITS_TEXT = 'Edit plan visits'
export const NUMBER_OF_VISITS_TEXT = 'Number of visits'
export const REASON_FOR_ADJUSTMENT_TEXT = 'Reason for adjustment'
export const PLAN_PURCHASED_TEXT = 'Purchased'
export const PLAN_EXPIRES_TEXT = 'Expires'
export const PLAN_REMAINING_TEXT = 'Remaining'
export const UPDATE_VISITS_TEXT = 'Update visits'
export const PLAN_VISITS_UPDATED_TEXT = 'Plan visits updated!'
export const PLAN_CANCELLED_TEXT = 'Plan cancelled'
export const GO_BACK_TEXT = 'Go back'
export const CANCEL_PLAN_CONFIRM_TITLE_TEXT = 'Confirm cancellation'
export const REASON_FOR_CANCELLATION_TEXT = 'Reason for cancellation'

export const PLEASE_SPECIFY_TEXT = 'Please specify...'
export const INVALID_ZIP_CODE_ERROR_TEXT = 'ZIP code'
export const PAST_VISITS_TEXT = 'Past visits'
export const UPCOMING_VISITS_TEXT = 'Upcoming visits'
export const EMPTY_PAST_VISITS_SECTION_TEXT = 'No past visits'
export const EMPTY_UPCOMING_VISITS_SECTION_TEXT = 'No upcoming visits'
export const STATUS_TEXT = 'Status'
export const VISIT_NOTE_TEXT = 'Visit note'
export const VISIT_TEXT = 'Visit'
export const VISIT_LOWER_TEXT = 'visit'
export const CLOSE_TEXT = 'Close'
export const PROVIDER_TEXT = 'Provider'
export const STATUS_PENDING_TEXT = 'PENDING'
export const STATUS_XMIT_TEXT = 'XMIT'
export const STATUS_XMIT_FAILED_TEXT = 'XMIT_FAILED'
export const STATUS_PRINTED_TEXT = 'PRINTED'
export const STATUS_CANCELED_TEXT = 'CANCELED'
export const STATUS_CANCEL_PENDING_TEXT = 'CANCEL_PENDING'
export const STATUS_CANCEL_DENIED_TEXT = 'CANCEL_DENIED'
export const PRESCRIBED_BY_TEXT = 'Prescriber'
export const DISPENTSE_AMOUNT_TEXT = 'Dispense amount'
export const QUANTITY_TEXT = 'Quantity'
export const DIRECTIONS_TEXT = 'Directions'
export const FREQUENCY_TEXT = 'Frequency'
export const FOR_TEXT = 'for'
export const DAY_TEXT = 'day'
export const DAYS_ONLY_TEXT = 'days'
export const REFILLS_TEXT = 'Refills'
export const PHARMACY_TEXT = 'Pharmacy'
export const NCPDP_ID_TEXT = 'NCPDP ID'
export const PHONE_TEXT = 'Phone'
export const STREET_TEXT = 'Street'
export const ZIP_TEXT = 'ZIP'
export const CREATED_TEXT = 'Created'
export const VISIT_NOTE_BLOCK_NOTE_SECTION_TITLE = 'Note'
export const NO_NOTES_TEXT = 'No notes'
export const PATIENT_INSTRUCTIONS_TITLE_TEXT = 'Patient instructions'
export const VISIBLE_TO_PATIENT_IN_VISIT_SUMMARY_TEXT = 'Visible to patient in visit summary.'
export const NO_PATIENT_INSTRUCTIONS_TEXT = 'No patient instructions'
export const VIDEO_CALL_NOTES_PRESCRIPTIONS_TITLE_TEXT = 'Prescriptions'
export const NO_PRESCRIPTIONS_TEXT = 'No prescriptions'
export const VISIT_DATE_TIME_TEXT = 'Visit date/time'
export const ICD_10_CODES_TEXT = 'ICD-10 codes'
export const MESSAGE_TEXT = 'Message text'
export const GENDER = 'Gender'
export const SERVICE = 'Service'
export const HEIGHT_FT_TEXT = 'Height (ft)'
export const HEIGHT_IN_TEXT = 'Height (in)'
export const WEIGHT_LBS_TEXT = 'Weight (lbs)'
export const VALUES_UPDATED_SUCCESSFULLY_TEXT = 'Values updated successfully!'
export const STATES_INFORMATION_TEXT = 'States information'
export const CONFIGURE_STATE_OPTIONS = 'Configure state-specific options'
export const SAVE_BTN_ICON_ALT = 'saveIcon'
export const SELECT_STATES_TEXT = 'Select state(s)'
export const NO_CHANGES_TEXT = 'No changes'
export const LICENSES_ARE_DISABLED = 'Licenses are disabled'
export const NAME_TEXT = 'Name'
export const COST_TEXT = 'Cost'
export const DESCRIPTION_TEXT = 'Description'
export const LENGTH_TEXT = 'Length'
export const CANCELATION_FEE_TEXT = 'Cancellation fee'
export const ADDITIONAL_CONCENT_FORMS_TEXT = 'Consent forms'
export const NO_ADDITIONAL_CONCENT_FORMS_TEXT = 'No consent forms'
export const NO_INTAKE_FORMS_TEXT = 'No intake form'
export const PATIENT_LOCATION_TEXT = 'Patient location'
export const YES_CAPITALIZE_TEXT = 'Yes'
export const NO_CAPITALIZE_TEXT = 'No'
export const TIME_ZONE = 'Time zone'
export const ACCOUNT_ON_HOLD_TEXT = 'Account on hold'
export const PATIENT_ACCOUNT_IS_ON_HOLD = 'This patient’s account is on hold.'
export const REMOVE_ALLERGIES_CONFIRMATION =
  "This will remove all existing allergies from the patient's chart. \n Do you wish to continue?"
export const ARE_YOU_SURE = 'Are you sure?'
export const MAT_MOUD_TEXT = 'MAT/MOUD'
export const VISIT_TYPE = 'visit type'

export const STATUS_VALUES_MAP = new Map([
  [STATUS_PENDING_TEXT, 'Pending'],
  [STATUS_XMIT_TEXT, 'Sent'],
  [STATUS_XMIT_FAILED_TEXT, 'Failed to send'],
  [STATUS_PRINTED_TEXT, 'Printed'],
  [STATUS_CANCELED_TEXT, 'Canceled'],
  [STATUS_CANCEL_PENDING_TEXT, 'Cancel pending'],
  [STATUS_CANCEL_DENIED_TEXT, 'Cancel denied'],
])
export const DELETE_ALERT_TEXT = 'Delete alert'
export const DELETE_REMARK_TEXT = 'Delete visit remark'
export const CANCEL_TEXT = 'Cancel'
export const ARE_YOU_SURE_DELETE_ALERT_TEXT = 'Are you sure you want to delete this alert?'
export const ARE_YOU_SURE_DELETE_REMARK_TEXT = 'Are you sure you want to delete this visit remark?'

export const APPOINTMENT_INFO_PATIENT_NAME_ROW_ID = 'patientNameRow'
export const PATIENTS_INFO_PREFFERED_NAME_ID = 'patientsInfoPrefferedName'

export const SESSION_ON_STORAGE_KEY = 'sessionOn'
export const IS_LAST_PAGE_WAS_CALENDAR_DETAILS_VIEW_LOCAL_STORAGE_KEY = 'isLastPageWasCalendarDetailsView'
export const APPOINTMENT_ADDITIONAL_INFO_METHOD_OPTION = 'Method'

export const APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION = 'Visit'
export const APPOINTMENT_ADDITIONAL_INFO_AMOUNT_OPTION = 'Amount'
export const APPOINTMENT_ADDITIONAL_INFO_EMAIL_OPTION = 'Email'
export const APPOINTMENT_ADDITIONAL_INFO_BOOKING_STATE_OPTION = 'Booking state'
export const APPOINTMENT_ADDITIONAL_INFO_PROVIDER_NAME_OPTION = 'Provider'
export const APPOINTMENT_ADDITIONAL_INFO_PHONE_OPTION = 'Phone'
export const APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION = 'Visit status'
export const APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION = 'Patient address'
export const APPOINTMENT_INFO_ID_CONSTANT_PART = 'appointmentInfo'
export const CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_TITLE = 'Please confirm cancellation'
export const CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_BODY_TEXT =
  'Deletion does not cancel patients who previously booked during this event.'
export const CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_PRIMARY_BUTTON_TEXT = 'Confirm'
export const CALENDAR_PAGE_DELETE_EVENT_CONFIRMATION_POP_UP_SECONDARY_BUTTON_TEXT = 'Close'
export const METHOD = 'Method'
export const PRICE = 'Price'
export const STATE = 'State'
export const VISIT = 'Visit'
export const CREDIT_CARD = 'Credit card'
export const TIMEZONE = 'TimeZone'
export const oneYearMS = 31557600000

export const apiErrorCodes = {
  MESSAGE_NOT_VALID: 'MessageNotValid',
  FORBIDDEN: 'Forbidden',
  ALERT_NOT_FOUND: 'AlertNotFound',
  VISIT_NOT_FOUND: 'VisitNotFound',
  COUNT_NOT_VALID: 'CountNotValid',
  OFFSET_NOT_VALID: 'OffsetNotValid',
  FILE_TAG_NOT_VALID: 'FileTagNotValid',
  FILE_NOT_FOUND: 'FileNotFound',
  FILE_NOT_VALID: 'FileNotValid',
  PROVIDER_NOT_FOUND: 'ProviderNotFound',
  SERVICE_TYPE_NOT_FOUND: 'ServiceTypeNotFound',
  PAYMENT_ERROR: 'PaymentError',
  PATIENT_NOT_FOUND: 'PatientNotFound',
  ADDRESS_NOT_VALID: 'AddressNotValid',
  THIRD_PARTY_ERROR: 'ThirdPartyError',
  DATE_TIME_NOT_VALID: 'DateTimeNotValid',
  METHOD_NOT_VALID: 'MethodNotValid',
  CREDIT_AMOUNT_CHANGED: 'CreditAmountChanged',
  PRICE_NOT_VALID: 'PriceNotValid',
  STATE_CODE_NOT_VALID: 'StateCodeNotValid',
  VISIT_FORBIDDEN: 'VisitForbidden',
  VISIT_TYPE_NOT_FOUND: 'VisitTypeNotFound',
  CREDIT_CARD_NOT_FOUND: 'CreditCardNotFound',
  ACCOUNT_NOT_ACTIVE: 'AccountNotActive',
  CREDIT_AMOUNT_NOT_VALID: 'CreditAmountNotValid',
  TIME_ZONE_NOT_VALID: 'TimeZoneNotValid',
  GENDER_NOT_VALID: 'GenderNotValid',
  INTAKE_FORM_NOT_FOUND: 'IntakeFormNotFound',
  NAME_NOT_UNIQUE: 'NameNotUnique',
  PERIOD_NOT_VALID: 'PeriodNotValid',
  PERMISSION: 'Permission',
}

export const visitListStatuses = {
  IN_WAITING_ROOM: 'inwaitingroom',
  IN_WAITING_ROOM_BACK: 'inwaitingroomback',
  IN_PROGRESS: 'inprogress',
  UNRESOLVED: 'unresolved',
  RESOLVED: 'resolved',
  CANCELED_BY_PATIENT: 'cancelledbypatient',
  SCHEDULED_BY_PATIENT: 'scheduledbypatient',
  RESCHEDULED_BY_PATIENT: 'rescheduledbypatient',
  ENDED: 'ended',
  SUCCESSFUL: 'completed',
  CANCELED_BY_STAFF: 'cancelledbyadmin',
  SCHEDULED_BY_ADMIN: 'scheduledbyadmin',
  RESCHEDULED_BY_ADMIN: 'rescheduledbyadmin',
}

export const visitListStatusesEncrypted = {
  IN_WAITING_ROOM: 'In waiting room',
  IN_WAITING_ROOM_BACK: 'In waiting room back',
  IN_PROGRESS: 'In progress',
  UNRESOLVED: 'Unresolved',
  RESOLVED: 'Resolved',
  CANCELED_BY_PATIENT: 'Canceled by patient',
  SCHEDULED_BY_PATIENT: 'Patient scheduled',
  RESCHEDULED_BY_PATIENT: 'Patient rescheduled',
  ENDED: 'Ended',
  SUCCESSFUL: 'Complete',
  CANCELED_BY_STAFF: 'Canceled by staff',
  SCHEDULED_BY_ADMIN: 'Staff scheduled',
  RESCHEDULED_BY_ADMIN: 'Staff rescheduled',
}

export const visitsStatuses = {
  [visitListStatuses.IN_WAITING_ROOM]: visitListStatusesEncrypted.IN_WAITING_ROOM,
  [visitListStatuses.IN_WAITING_ROOM_BACK]: visitListStatusesEncrypted.IN_WAITING_ROOM,
  [visitListStatuses.IN_PROGRESS]: visitListStatusesEncrypted.IN_PROGRESS,
  [visitListStatuses.UNRESOLVED]: visitListStatusesEncrypted.UNRESOLVED,
  [visitListStatuses.RESOLVED]: visitListStatusesEncrypted.RESOLVED,
  [visitListStatuses.CANCELED_BY_PATIENT]: visitListStatusesEncrypted.CANCELED_BY_PATIENT,
  [visitListStatuses.ENDED]: visitListStatusesEncrypted.ENDED,
  [visitListStatuses.CANCELED_BY_STAFF]: visitListStatusesEncrypted.CANCELED_BY_STAFF,
  [visitListStatuses.SUCCESSFUL]: visitListStatusesEncrypted.SUCCESSFUL,
  [visitListStatuses.SCHEDULED_BY_PATIENT]: visitListStatusesEncrypted.SCHEDULED_BY_PATIENT,
  [visitListStatuses.RESCHEDULED_BY_PATIENT]: visitListStatusesEncrypted.RESCHEDULED_BY_PATIENT,
  [visitListStatuses.SCHEDULED_BY_ADMIN]: visitListStatusesEncrypted.SCHEDULED_BY_ADMIN,
  [visitListStatuses.RESCHEDULED_BY_ADMIN]: visitListStatusesEncrypted.RESCHEDULED_BY_ADMIN,
}

export const tableViewOptions = ['Upcoming', 'Past']
export const visitsListModes = {
  UPCOMING_MODE: 'Upcoming',
  PAST_MODE: 'Past',
}

export const VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY = 'selectedVisitPageFilterStatus'
export const VISITS_VISIT_FILTER_LOCAL_STORAGE_KEY = 'selectedVisitPageFilterVisitTypesAdmin'
export const VISITS_TAG_FILTER_LOCAL_STORAGE_KEY = 'selectedVisitPageFilterTagTypesAdmin'
export const visitTableTitles = {
  BOOKING_ID: 'Booking ID',
  DATE: 'Date',
  SCHEDULED_ON: 'Scheduled on',
  STATUS: 'Status',
  VISIT: 'Visit',
  PROVIDER: 'Provider',
  PATIENT: 'Patient',
  PAYMENT_ID: 'Payment ID',
  REMARKS: 'Remarks',
  TAGS: 'Tags',
}

export const QUICK_MD_TITLE_TEXT = 'QuickMD'
export const HEIGHT_FT_OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
export const HEIGHT_IN_OPTIONS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']

export const MARITAL_STATUS_OPTIONS = [
  'Annulled',
  'Divorced',
  'Legally separated',
  'Married',
  'Polygamous',
  'Never married',
  'Domestic partner',
  'Single',
  'Widowed',
  'Prefer not to say',
]

export const RACIAL_BACKGROUND_OPTIONS = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Caucasian',
  'Hispanic or Latino',
  'Native Hawaiian or other Pacific Islander',
  'Prefer not to say',
]

export const SEX_AT_BIRTH_OPTIONS = ['Male', 'Female']

export const profilePermissions = {
  ON_HOLD_PERMISSION: 'patient.block',
  CAN_EDIT_EMAIL: 'patient.changeemail',
  MANAGE_PRESCRIPTION_STATUS: 'prescription.status.manage',
  CAN_EDIT_PACKAGE: 'patient.package.edit',
  CREATE_PRESCRIPTION_ENCOUNTER: 'prescription.encounter.create',
  DELETE_MEDICAL_RECORDS: 'visit.medicalrecords.delete',
}

// Delete a single visit note / patient instruction (QMD-4870)
export const DELETE_NOTE_TITLE_TEXT = 'Delete note'
export const DELETE_PATIENT_INSTRUCTION_TITLE_TEXT = 'Delete patient instruction'
export const DELETE_NOTE_ARIA_LABEL_TEXT = 'Delete note'
export const DELETE_PATIENT_INSTRUCTION_ARIA_LABEL_TEXT = 'Delete patient instruction'
export const DELETE_NOTE_CONFIRMATION_TEXT = "This permanently deletes this note from the visit and can't be undone."
export const DELETE_PATIENT_INSTRUCTION_CONFIRMATION_TEXT =
  "This permanently deletes this patient instruction from the visit and can't be undone."
export const DELETE_MEDICAL_RECORD_REASON_LABEL_TEXT = 'Reason for deletion'
export const NOTE_DELETED_TEXT = 'Note deleted'
export const PATIENT_INSTRUCTION_DELETED_TEXT = 'Patient instruction deleted'

export const MANAGEMENT_SERVICE_TYPES_TAB_TITLE_TEXT = 'Service types'
export const MANAGEMENT_SERVICE_TYPES_TAB_SUBTITLE_TEXT = 'Create service types for patients to choose from'
export const MANAGEMENT_SERVICE_TYPES_TAB_REORDER_BTN_TITLE_TEXT = 'Reorder'
export const MANAGEMENT_SERVICE_TYPES_TAB_NEW_BTN_TITLE_TEXT = 'New'
export const MANAGEMENT_SERVICE_TYPES_TAB_NEW_BTN_ID_TEXT = 'newServiceTypesBtn'
export const MANAGEMENT_SERVICE_TYPES_TAB_SAVE_BTN_TITLE_TEXT = 'Save'
export const MANAGEMENT_SERVICE_TYPES_TAB_SAVE_BTN_IMG_ALT_TEXT = 'Save order'
export const MANAGEMENT_SERVICE_TYPES_TAB_REORDER_BTN_IMG_ALT_TEXT = 'Reorder service items'
export const MANAGEMENT_SERVICE_TYPES_TAB_NEW_BTN_IMG_ALT_TEXT = 'Add serivce'

export const LOCAL_STORAGE_STATE_TO_CALENDAR = 'LocalStorageStateToCalendar'
export const LOCAL_STORAGE_STATE_TO_PAST_VISIT = 'LocalStorageStateToPastVisit'

export const ABBREVIATION_TO_DAY_OF_WEEK = {
  Sun: 'sunday',
  Mon: 'monday',
  Tue: 'tuesday',
  Wed: 'wednesday',
  Thu: 'thursday',
  Fri: 'friday',
  Sat: 'saturday',
}

export const NAVIGATION_TYPES = {
  NAVIGATE: 'navigate',
  RELOAD: 'reload',
  BACK_FORWARD: 'back_forward',
  RESERVED: 'reserved',
}

export const PAST_VISIT = ['ended', 'unresolved', 'completed', 'resolved', 'cancelledbypatient', 'cancelledbyadmin']
export const UPCOMING_VISIT = [
  'scheduledbypatient',
  'scheduledbyadmin',
  'inwaitingroom',
  'inwaitingroomback',
  'inprogress',
  'rescheduledbypatient',
  'rescheduledbyadmin',
]
export const DRUG_SCREEN_STATUS = {
  verified: 'verified',
  legacyunverified: 'legacyunverified',
  addressunverified: 'addressunverified',
  expired: 'expired',
  due: 'due',
  duesoon: 'duesoon',
  exempt: 'exempt',
}

export const ID_VERIFICATION_STATUSES = {
  warning: 'warning',
  failed: 'failed',
  verified: 'verified',
  processing: 'processing',
  manuallyverified: 'manuallyverified',
  unverified: 'unverified',
  legacyverified: 'legacyverified',
  requested: 'requested',
}

export const tagsFilterOptions = [
  // Flags
  { value: '1st', id: 'IsNewForServiceType', type: 'flag' },
  { value: 'New', id: 'IsNewForPatient', type: 'flag' },

  // Drug Screen Statuses
  { value: 'Drug screen verified', id: DRUG_SCREEN_STATUS.verified, type: 'drugScreen' },
  { value: 'Drug screen expired', id: DRUG_SCREEN_STATUS.expired, type: 'drugScreen' },
  {
    value: 'Patient changed state, revalidate',
    id: DRUG_SCREEN_STATUS.addressunverified,
    type: 'drugScreen',
  },
  { value: 'No drug screen on file', id: DRUG_SCREEN_STATUS.due, type: 'drugScreen' },
  { value: 'Drug screen due soon', id: DRUG_SCREEN_STATUS.duesoon, type: 'drugScreen' },
  { value: 'Drug screen exempt', id: DRUG_SCREEN_STATUS.exempt, type: 'drugScreen' },
  {
    value: 'Prior drug screen, revalidate',
    id: DRUG_SCREEN_STATUS.legacyunverified,
    type: 'drugScreen',
  },

  // Identity Verification Statuses
  {
    value: 'ID not verified',
    id: ID_VERIFICATION_STATUSES.unverified,
    type: 'identityVerification',
  },
  {
    value: 'ID request sent',
    id: ID_VERIFICATION_STATUSES.requested,
    type: 'identityVerification',
  },
  {
    value: 'ID legacy verified',
    id: ID_VERIFICATION_STATUSES.legacyverified,
    type: 'identityVerification',
  },
  {
    value: 'ID manually verified',
    id: ID_VERIFICATION_STATUSES.manuallyverified,
    type: 'identityVerification',
  },
  {
    value: 'ID verified',
    id: ID_VERIFICATION_STATUSES.verified,
    type: 'identityVerification',
  },
  {
    value: 'ID warning',
    id: ID_VERIFICATION_STATUSES.warning,
    type: 'identityVerification',
  },
  {
    value: 'ID failed',
    id: ID_VERIFICATION_STATUSES.failed,
    type: 'identityVerification',
  },
]
